import Home from "@routes/Home.svelte";
import Dashboard from "@routes/Dashboard.svelte";
import PasswordResetConfirm from "@routes/PasswordResetConfirm.svelte";

export const routes = {
  "/confirm": PasswordResetConfirm,
  "/dashboard": Dashboard,
  "/*": Home,
  "/:policy/*": Home,
  // "/:policy/notfound": NotFound
};
